module.exports = __webpack_public_path__ + "static/media/k.1e800050.png";